const BASE_URL = '/api/meta-accounts';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export interface MetaAccount {
  id: number;
  account_alias: string;
  meta_user_id: string;
  meta_business_id: string | null;
  scopes: string;
  needs_reauth: boolean;
  created_at: string;
  updated_at: string;
}

export async function listMetaAccounts(): Promise<MetaAccount[]> {
  return fetchJson<MetaAccount[]>(BASE_URL);
}

export async function disconnectMetaAccount(id: number): Promise<void> {
  await fetchJson(`${BASE_URL}/${id}`, { method: 'DELETE' });
}
